import { GlobalLocation } from "../../application/GeoLocation";
import { logService } from "@Engage.Core";
import { CookiesStorageService } from "@Engage.Data/services";
import { StorageKeys } from "@Engage.Data/constants/Constants";
export class FPPlugin {
    constructor() {
        this.name = "FP";
    }
    async init() {
        var _a;
        try {
            // fp.min.js is merged into the bundle at build time
            const fp = window.Fingerprint;
            if (fp === null || fp === void 0 ? void 0 : fp.init) {
                // await if Fingerprint.init() returns a promise (writes anonDeviceId async)
                const result = fp.init();
                if (result && typeof result.then === 'function') {
                    await result;
                }
                else {
                    // Fingerprint.init() is sync or doesn't return a promise —
                    // poll until anonDeviceId cookie is written (max 3s)
                    await this.waitForUserId(3000);
                }
            }
            await GlobalLocation.setInformation();
            logService.log("[FPPlugin] initialized", `userId=${(_a = this.getUserId()) !== null && _a !== void 0 ? _a : 'not set'}`);
        }
        catch (err) {
            logService.error("[FPPlugin] Failed to initialize", err);
        }
    }
    getUserId() {
        var _a;
        return (_a = CookiesStorageService.get(StorageKeys.ConnextUserId, {
            expandKey: false,
            isSecureValue: false,
            useRootDomain: true
        })) !== null && _a !== void 0 ? _a : null;
    }
    /**
     * Poll until anonDeviceId cookie is written or timeout expires.
     * Fingerprint.init() writes the cookie asynchronously after DOM/network ops.
     */
    waitForUserId(timeoutMs) {
        return new Promise((resolve) => {
            const interval = 50;
            let elapsed = 0;
            const check = () => {
                if (this.getUserId()) {
                    resolve();
                    return;
                }
                elapsed += interval;
                if (elapsed >= timeoutMs) {
                    logService.warn("[FPPlugin] anonDeviceId not set after timeout — continuing");
                    resolve();
                    return;
                }
                setTimeout(check, interval);
            };
            check();
        });
    }
}
